import {
  HeadingNode,
  Klass,
  LexicalNode,
  LexicalNodeReplacement,
  ListItemNode,
  ListNode,
  TableCellNode,
  TableNode,
  TableRowNode
} from '@eastcoal/editor/exports'
import { ImageNode } from '@eastcoal/editor/nodes/ImageNode'
import { TableControllerNode } from '@eastcoal/editor/nodes/TableControllerNode'
import { TableWrapperNode } from '@eastcoal/editor/nodes/TableWrapperNode'

import { TableVariableNode } from './TableVariableNode'
import { TextVariableNode } from './TextVariableNode'

export const editorNodes: ReadonlyArray<
  Klass<LexicalNode> | LexicalNodeReplacement
> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  ImageNode,
  TableWrapperNode,
  TableControllerNode,
  TableNode,
  TableRowNode,
  TableCellNode,
  TextVariableNode,
  TableVariableNode
]
